import { useDecision } from '@walmart-dataventures/feature-flag-sdk-react';
import useLocalStorage from './useLocalStorage.ts';

function useFeatureDecision(featureFlagKey: string) {
  const panelistId = useLocalStorage('panelistId');
  return useDecision(featureFlagKey, undefined, {
    overrideUserId: panelistId
  });
}

export default useFeatureDecision;
